import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const Pagination = ({ total, page, size, onChange, testid }) => {
  const pages = Math.max(1, Math.ceil(total / size));
  const p = Math.min(page, pages);
  const from = total === 0 ? 0 : (p - 1) * size + 1;
  const to = Math.min(total, p * size);
  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-slate-200 px-4 py-3" data-testid={testid}>
      <div className="flex items-center gap-2 text-sm text-slate-500">
        <span>Rows per page</span>
        <Select value={String(size)} onValueChange={(v) => onChange({ page: 1, size: Number(v) })}>
          <SelectTrigger className="h-8 w-20" data-testid={`${testid}-size`}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {[10, 25, 50, 100].map((n) => (
              <SelectItem key={n} value={String(n)}>{n}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex items-center gap-2">
        <span className="text-sm text-slate-500" data-testid={`${testid}-info`}>
          {from}–{to} of {total}
        </span>
        <Button variant="outline" size="sm" disabled={p <= 1} onClick={() => onChange({ page: p - 1, size })} data-testid={`${testid}-prev`}>
          <ChevronLeft className="mr-1 h-3.5 w-3.5" /> Previous
        </Button>
        <Button variant="outline" size="sm" disabled={p >= pages} onClick={() => onChange({ page: p + 1, size })} data-testid={`${testid}-next`}>
          Next <ChevronRight className="ml-1 h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
};
